'use strict';

import UserHandler from './components/UserHandler.vue';

export default class {

    constructor() {
        // Register component globaly
        Vue.component('user-handler', UserHandler);

    }
}
